import styled from 'styled-components'
import { colors, device } from '../../styles/GlobalVariables'
import Link from '../Link/Link'

export const Container = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 10px 0;
  direction: ltr;
`

export const PagerButton = styled(Link)<{ active: boolean }>`
  display: grid;
  align-content: center;
  justify-items: center;
  max-width: 29px;
  max-height: 29px;
  height: 29px;
  width: 29px;
  border-radius: 4px;
  background-color: ${props => (props.active ? colors.darkBlue : 'unset')};

  font-size: 19px;
  font-weight: 400;
  color: ${props => (props.active ? colors.white : colors.black)};

  cursor: ${props => (props.active ? 'default' : 'pointer')};

  ${device.medium} {
    font-size: 20px;
  }
`

export const ArrowWrapper = styled.div`
  a {
    display: flex;
    align-items: center;
  }

  svg {
    font-size: 16px;
  }
`
